export const actionKey = '@@MODERATION';
export const reduxKey = '@@MODERATION';

//# sourceMappingURL=constants.js.map